const localStorageAuthKey = 'persist:auth';
const localStorageRememberMeKey = 'rememberMe';

const unauthorized_status = 401;
const forbidden_status = 403;

export { localStorageAuthKey, localStorageRememberMeKey, unauthorized_status, forbidden_status };
